var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.5,
    height: 23.5,
    viewBox: "0 0 25.5 23.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10234",
    "data-name": "Group 10234",
    transform: "translate(19923.25 21827.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10233",
    "data-name": "Group 10233",
    transform: "translate(-19923 -21827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7284",
    "data-name": "Path 7284",
    className: "cls-1",
    d: "M17.5,39.192H12.46l.715-1.021a.5.5,0,0,0-.819-.574L11.24,39.192H7.5a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5v-6A.5.5,0,0,0,17.5,39.192Zm-.5,6H8v-5h9Z",
    transform: "translate(-7 -23.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7285",
    "data-name": "Path 7285",
    className: "cls-1",
    d: "M38.5,25H33.76l-6.3-9H31.5a.5.5,0,0,0,.5-.5v-6a.5.5,0,0,0-.5-.5h-10a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h3.04l-.6.852a.5.5,0,0,0,.819.574l1-1.425h.479l6.3,9H28.5a.5.5,0,0,0-.5.5v6a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,.5-.5v-6A.5.5,0,0,0,38.5,25ZM22,10h9v5H22ZM38,31H29V26h9Z",
    transform: "translate(-14 -9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7286",
    "data-name": "Path 7286",
    className: "cls-1",
    d: "M21.881,31.618l1.146-1.639a.5.5,0,0,0-.819-.573l-1.146,1.638a.5.5,0,1,0,.819.574Z",
    transform: "translate(-13.986 -19.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7287",
    "data-name": "Path 7287",
    className: "cls-1",
    d: "M11.146,29.853a.5.5,0,0,0,.707,0l.646-.647.647.647a.5.5,0,0,0,.707-.707l-.647-.646.647-.647a.5.5,0,1,0-.707-.707l-.646.647-.646-.647a.5.5,0,0,0-.707.707l.647.647-.647.646A.5.5,0,0,0,11.146,29.853Z",
    transform: "translate(-9 -18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignWhite);
export default __webpack_public_path__ + "static/media/assignWhite.f14fea70f9bf4632d150fc146c345b73.svg";
export { ForwardRef as ReactComponent };